import { usePage } from '@inertiajs/react';

import { Footer } from '@/theme3/components/layout/Footer';
import { Header } from '@/theme3/components/layout/Header';
import { TopBar } from '@/theme3/components/layout/TopBar';

export default function StoreLayoutTheme3({ children }) {
    const { frontendTheme } = usePage().props;

    return (
        <div
            className="min-h-screen bg-[#fff8fa] text-slate-900 antialiased"
            data-frontend-theme={frontendTheme?.name ?? 'theme3'}
        >
            <div className=" flex min-h-screen w-full flex-col  ">
                <TopBar />
                <Header />

                <main className="flex-1">
                    <div >
                        {children}
                    </div>
                </main>

                <Footer />
            </div>
        </div>
    );
}
